export class RegisterModel{
    fullName: string
    birthDate: any
    gender: number
    phone: string
    email: string
    primaryCityId: string
    schoolName: string
    universityId: string
    departmant: string
    educationLevel: number
    professionType: number
    company: string
    position: string
    password: string
    isKvkk: boolean
    isOtherUniversity: boolean
    isAlumni: boolean
    selectedCategories = []
}

export class ForgetPasswordModel{
    email: string;
}

export class ResetPasswordModel{
    token: string
    newPassword: string
    confirmNewPassword: string
}

export class ActivateAccountModel {
    activationToken: string
}